import React from 'react';
import Popup from 'reactjs-popup';
import { Worker, Viewer, ProgressBar, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { pdfjs } from 'react-pdf';
import { useTranslate } from '../TranslationText';

export default function PdfViewerPopup({ open, onClose, title, attachmentUrl }) {
    const { translate } = useTranslate();
    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        toolbarPlugin: {
            fullScreenPlugin: {
                getFullScreenTarget: (pagesContainer) => pagesContainer.closest('[data-testid="default-layout__body"]'),
                renderExitFullScreenButton: (props) => <></>,
            },
        },
    });

    const isImage = !!attachmentUrl && /\.(jpg|jpeg|png|gif|webp)$/i.test(attachmentUrl);

    return (
        <Popup 
            open={open}
            onClose={onClose}
            modal
            closeOnEscape={true}
            closeOnDocumentClick={true}
            lockScroll={true}
            contentStyle={{ width: '98%', height: '90vh', maxWidth: '1600px', display: 'flex', flexDirection: 'column', padding: '0', backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden' }}
            overlayStyle={{ zIndex: 5000, backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
            {(close) => (
                <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ padding: '15px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h4 className="m-0 fw-bold">{title}</h4>
                        <button type="button" className="btn-close" aria-label="Close" onClick={close}></button>
                    </div>
                    
                    <div style={{ flex: 1, position: 'relative', overflow: 'hidden', backgroundColor: '#f0f0f0' }}>
                        {isImage ? (
                            <img src={attachmentUrl} alt={title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                        ) : (
                            <Worker workerUrl={`//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`}>
                                <Viewer
                                    renderLoader={(percentages) => (
                                        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                            <div className="spinner-border text-danger" role="status" style={{ width: '3rem', height: '3rem' }}>
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <div className="mt-3 fw-bold text-muted">
                                                {translate('web.loading', 'Loading...')} {Math.round(percentages)}%
                                            </div>
                                        </div>
                                    )}
                                    fileUrl={attachmentUrl}
                                    plugins={[defaultLayoutPluginInstance]}
                                    defaultScale={SpecialZoomLevel.PageFit}
                                />
                            </Worker>
                        )}
                    </div>
                </div>
            )}
        </Popup>
    );
}
